import React from 'react';

import PanelHeader from './PanelHeader';
import PanelBody from './PanelBody';

const PanelPermisos = (props) => {
    return (
        <div className="panel panel-default">
            <div className="panel-body">
                <PanelHeader permiso={props.permiso}
                    permisos={props.permisos}
                    deletePermiso={props.deletePermiso}
                    selectProducto={props.selectProducto}
                    selectCategoria={props.selectCategoria}
                    selectPrograma={props.selectPrograma} />
                <PanelBody permiso={props.permiso}
                    errorMessageFunciones={props.errorMessageFunciones}
                    selectTodasFunciones={props.selectTodasFunciones}
                    unselectTodasFunciones={props.unselectTodasFunciones}
                    checkFuncion={props.checkFuncion} />
            </div>
        </div>
    );
}

export default PanelPermisos;